import { pills } from '../data/pills';
import { getStatus } from './biomarkers';
import type { Biomarker, Pill } from '../types/platform';

export function getFlaggedIds(panel: Biomarker[]): string[] {
  return panel.filter((b) => getStatus(b) !== 'optimal').map((b) => b.id);
}

export function getRecommendedPillIds(panel: Biomarker[]): string[] {
  const flagged = getFlaggedIds(panel);
  return pills
    .filter((p) => p.goals.includes('longevity') && p.targets.some((t) => flagged.includes(t)))
    .map((p) => p.id);
}

export const PACK_DAYS = 30;

export function pillCountLabel(p: Pill): string {
  return `${p.count} ${p.form}${p.count > 1 ? 's' : ''}`;
}

export function sachetPillCount(list: Pill[], timing: Pill['timing']): number {
  return list.filter((p) => p.timing === timing).reduce((sum, p) => sum + p.count, 0);
}

export function formatAED(value: number): string {
  return `AED ${value.toLocaleString('en-US')}`;
}
